import "./../styles.scss";

import { notification } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import CloseModal from "../../../components/icons/CloseModal";
import { editPackageValidation } from "../../../utils/validations";

const EditPackage = ({ ...props }) => {
  const { editmodalOpen, setEditModalOpen, getPackages, packageDetails, costumFields, packageNames, id } = props;

  const [disable, setDisable] = useState(false);
  const [initialValues, setInitialValues] = useState({
    oldname: packageDetails?.name,
    name: packageDetails?.name,
    assignedCollectionId: packageDetails?.assignedCollectionId ? packageDetails?.assignedCollectionId.join(",") : "",
    digitalKeywords: packageDetails?.digital_keywords,
    tags: packageDetails?.tags ? packageDetails?.tags.join(",") : "",
  });
  const closeModal = () => {
    setEditModalOpen(false);
  };

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      oldname: packageDetails?.name,
      name: packageDetails?.name,
      _id: packageDetails?._id,
      assignedCollectionId: packageDetails?.assignedCollectionId ? packageDetails?.assignedCollectionId.join(",") : "",
      digitalKeywords: packageDetails?.digital_keywords,
      tags: packageDetails?.tags ? packageDetails?.tags.join(",") : "",
    });
  }, [packageDetails]);

  const handleSubmit = () => {
    if (packageNames.filter((e) => e._id !== initialValues?._id && e.name === initialValues?.name).length > 0) {
      notification["error"]({ message: "Package Name Already Exists" });
    } else {
      setDisable(false);
      const payload = {
        package: {
          oldname: initialValues.oldname,
          name: initialValues.name,
          assignedCollectionId: initialValues?.assignedCollectionId
            ? initialValues?.assignedCollectionId.split(",")
            : [],
          digital_keywords: initialValues?.digitalKeywords,
          tags: initialValues?.tags ? initialValues?.tags.split(",") : [],
        },
        entityId: id,
        action: "update",
      };

      getPackages(payload);
      closeModal();
    }
  };

  const editPackageName = (e, setFieldValue) => {
    setFieldValue("name", e);
    setInitialValues({ ...initialValues, name: e });
  };
  const editPackageAssignedCollection = (e, setFieldValue) => {
    setFieldValue("assignedCollectionId", e);
    setInitialValues({ ...initialValues, assignedCollectionId: e });
  };

  const editDigitalKeywords = (e, setFieldValue) => {
    setFieldValue("digitalKeywords", e);
    setInitialValues({ ...initialValues, digitalKeywords: e });
  };
  const editTags = (e, setFieldValue) => {
    setFieldValue("tags", e);
    setInitialValues({ ...initialValues, tags: e });
  };
  return (
    <>
      <Modal
        isOpen={editmodalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Package Name</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialValues} validationSchema={editPackageValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Package Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="packagename"
                        value={initialValues?.name}
                        onChange={(e) => editPackageName(e.target.value, setFieldValue)}
                      />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Assigned Collection Ids <span className="required"></span>
                      </label>
                      <Field
                        className="form-control"
                        name="assignedCollectionId"
                        value={initialValues?.assignedCollectionId}
                        onChange={(e) => editPackageAssignedCollection(e.target.value, setFieldValue)}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Digital Keywords<span className="required"></span>
                      </label>
                      <Field
                        className="form-control"
                        name="digitalkeywords"
                        value={initialValues?.digitalKeywords}
                        onChange={(e) => editDigitalKeywords(e.target.value, setFieldValue)}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Tags<span className="required"></span>
                      </label>
                      <Field
                        className="form-control"
                        name="tags"
                        value={initialValues?.tags}
                        onChange={(e) => editTags(e.target.value, setFieldValue)}
                      />
                    </div>
                    <button className="btn btn-primary" type="submit">
                      Edit
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default EditPackage;
